import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Collapse } from "react-collapse";

import { LOCAL_STORAGE_PAYMENTS_TRAFFIC_REPORTS_FILTERS } from "const/localStorageKeys";
import { getISOTime } from "utils/helpers";
import { getDefaultDateRange } from "utils/helpers";
import PaymentsSectionHeader from "components/Payments/PaymentsSectionHeader";
import CommonDateFilter from "components/Payments/CommonDateFilter";
import { normalizeDateRange } from "components/Payments";
import { Spacer } from "components/base/Spacer";
import PaymentsTrafficReportsTable from "../../Payments/PaymentsTrafficReportsSection/PaymentsTrafficReportsTable";


export default ({
    paymentTrafficReportsItems,
    paymentTrafficReportsLoading,
    openModalRequestPayment,
    currencyName,
    getTrafficReportsList,
    isSupplier,
    accountId,
    service,
    // height = null
}) => {
    const { start: dateStart, end: dateEnd } = useMemo(() => getDefaultDateRange(6), []);

    const [showTable, setShowTable] = useState(true);
    const [filters, setFilters] = useState({
        start_end_date: [dateStart, dateEnd]
    });

    useEffect(() => {
        if (!accountId)
            return;

        const data = { target: { account_id: accountId } };
        data.filter = {
            start_date: getISOTime(dateStart),
            end_date: getISOTime(dateEnd)
        }
        getTrafficReportsList(data);
    }, [accountId, dateEnd, dateStart, getTrafficReportsList]);

    const handleChangeFilters = useCallback((value) => {
        const normalizedRange = normalizeDateRange(value?.start_end_date);

        if (!value || !normalizedRange)
            return;

        const [start_date, end_date] = normalizedRange;

        setFilters({
            start_end_date: normalizedRange
        });

        const filterData = {
            start_date: getISOTime(start_date),
            end_date: getISOTime(end_date),
            start_end_date: normalizedRange
        };

        localStorage.setItem(LOCAL_STORAGE_PAYMENTS_TRAFFIC_REPORTS_FILTERS, JSON.stringify(filterData));

        getTrafficReportsList({
            target: {
                account_id: accountId
            },
            filter: filterData
        });
    }, [accountId, getTrafficReportsList]);

    const toggleTable = useCallback(() => {
        setShowTable(prev => !prev);
    }, []);

    return (
        <>
            <PaymentsSectionHeader
                title="Traffic reports"
                show={showTable}
                callback={toggleTable}
            />

            <Collapse isOpened={showTable}>
                <div>
                    <Spacer />
                    <CommonDateFilter
                        filters={filters}
                        onChangeFilters={handleChangeFilters}
                    />

                    <Spacer />
                    <PaymentsTrafficReportsTable
                        height={160}
                        data={paymentTrafficReportsItems}
                        loading={paymentTrafficReportsLoading}
                        {...{
                            openModalRequestPayment,
                            currencyName,
                            isSupplier,
                            service
                        }}
                    />
                </div>
            </Collapse>
        </>
    );
};